import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchSummationsite } from './summationsiteAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk to fetch data with filters
export const fetchSummationsiteDataWithFilters = createAsyncThunk(
  'summationsite/fetchSummationsiteDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchSummationsite({ filter, options }); // Pass filters to the API
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const summationsiterSlice = createSlice({
  name: 'summationsite',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummationsiteDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSummationsiteDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchSummationsiteDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectSummationsiteData = (state) => state.summationsite.data;
export const selectSummationsiteStatus = (state) => state.summationsite.status;
export const selectSummationsiteError = (state) => state.summationsite.error;

export default summationsiterSlice.reducer;
